import Icon from '../components/Icon.vue'

Icon.register({"bible":{"width":448,"height":512,"paths":[{"d":"M448 358.4V25.6C448 9.6 438.4 0 422.4 0H96C41.6 0 0 41.6 0 96V416C0 470.4 41.6 512 96 512H422.4C435.2 512 448 502.4 448 486.4V470.4C448 464 444.8 457.6 438.4 451.2 435.2 435.2 435.2 390.4 438.4 377.6 444.8 374.4 448 368 448 358.4zM144 144C144 135.2 151.2 128 160 128H208V80C208 71.2 215.2 64 224 64H256C264.8 64 272 71.2 272 80V128H320C328.8 128 336 135.2 336 144V176C336 184.8 328.8 192 320 192H272V304C272 312.8 264.8 320 256 320H224C215.2 320 208 312.8 208 304V192H160C151.2 192 144 184.8 144 176V144zM380.8 448H96C76.8 448 64 435.2 64 416S80 384 96 384H380.8V448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bible.js
// module id = null
// module chunks = 